'use strict';

function register(angular) {
  return [
    'ReactNavigationService',
    function (ReactNavigationService) {
      return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
          function updateHref() {
            var path = attrs.reactHref || '';
            elem.attr('href', ReactNavigationService.buildUrl(path));
          }

          attrs.$observe('reactHref', updateHref);
          updateHref();
        },
      };
    },
  ];
}

module.exports = register;
